import {SET_SETTINGS} from "../../../constants/PlayerConstants";
import {SettingsObject} from "../../../@types/response";

export const SetSettingsAction = (data: SettingsObject) => ({
    type: SET_SETTINGS,
    payload: data
})